// extracted by mini-css-extract-plugin
module.exports = {"AdvantageItem":"AdvantageItem_AdvantageItem__3uwt-","AdvantageItemHeader":"AdvantageItem_AdvantageItemHeader__3U56V","AdvantageItemDesc":"AdvantageItem_AdvantageItemDesc__Jhx4B"};